import MenubarView from './MenubarView'
import Iframe from 'react-iframe'
import { useEffect} from 'react';


const GundilerView = () => {

    useEffect(() => {
    }, [])

    const mystyle = {
        height: "100%",
        width: "100%",
        position: 'relative'
    };
    return (
    
        <div style={mystyle}>
            <MenubarView/>   
            <Iframe url="https://amreporting.sevtekin.com/public/dashboard/28a9427c-ae1b-4d4a-b6db-683af44b1a10"
            width="100%"
            height="1200"
            position= "relative"
            frameBorder="0"
            />
        </div>
    );
}
export default GundilerView





       
